import Vue from 'vue'
import { CONSTANTS } from '@sohohouse/platform-resources'
import {
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations
} from '~/helpers/store'

const { VENUE_TYPES } = CONSTANTS

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchAccount ({ commit, getters, dispatch }) {
      const account = await platformAction({
        client: this.$api.profiles.accounts,
        method: 'get',
        commit,
        logError: this.$logError,
        commitData: false,
        include: []
      })

      if (getters.failed) {
        dispatch('ui/modals/open', 'critical-error', { root: true })
      } else {
        commit('saveAccount', account)
      }
    },
    async updateFavoriteCategories ({ commit, getters, dispatch }, categories) {
      await platformAction({
        client: this.$api.profiles.accounts,
        method: 'updateFavoriteContentCategories',
        params: categories,
        commit,
        logError: this.$logError,
        commitData: false
      })
      if (!getters.failed) {
        const prevCats = getters.favoriteContentCategories
        await dispatch('fetchAccount')
        dispatch('content/notes/clearSubscribedNotes', { prevCats }, { root: true })
      }
    },
    async updateFavoriteVenues ({ commit, getters, dispatch }, params) {
      await platformAction({
        client: this.$api.profiles.accounts,
        method: 'updateFavoriteVenues',
        params,
        commit,
        logError: this.$logError,
        commitData: false
      })

      if (!getters.failed) {
        const prevFavHouses = getters.favoriteVenues.map(h => h.id)
        await dispatch('fetchAccount')
        dispatch('events/events/updateLocationFilters', { prevFavHouses }, { root: true })
      }
    },
    async updateAccount ({ commit, getters, dispatch }, params) {
      const account = await platformAction({
        client: this.$api.profiles.accounts,
        method: 'update',
        params,
        commit,
        logError: this.$logError,
        commitData: false
      })

      if (params.analyticsConsent && account.analyticsConsent) {
        this.$gtm.activate(getters.id)
      }

      if (!getters.failed) {
        // TODO: this is fetching the relationship for localVenue (required) send this with the patch instead
        await dispatch('fetchAccount')
      }
    },
    subscribe ({ commit }, { params, token }) {
      const client = this.$api.profiles.accounts
      client.client.setHeader('X-Sh-Recaptcha-Response', token)

      return platformAction({
        client,
        method: 'create',
        params: {
          ...params,
          accountType: 'newsletter_subscription',
        },
        commit,
        logError: this.$logError,
        commitData: true
      })
    }
  },
  getters: {
    ...platformGetters,
    account: s => s.data,
    id: s => s.data.id,
    favoriteContentCategories: s => s.data.favoriteContentCategories || [],
    favoriteVenues: s => {
      if (!s.data.favoriteVenues) return []
      return s.data.favoriteVenues.filter(
        venue => venue.venueType === VENUE_TYPES.HOUSE || venue.venueType === VENUE_TYPES.CWH
      ) || []
    },
    localHouse: s => s.data.localHouse || {},
    calendarSubscriptionUrl: s => s.data.calendarSubscriptionUrl,
    membershipPaymentUrl: s => s.data.membershipPaymentUrl,
    canAccessApp: s => s.data.canAccessApp,
    hasMadeAnalyticsDecision: s => s.data.analyticsConsent !== null,
    analyticsConsent: s => s.data.analyticsConsent,
    agreesToTermsAndConditions: s => s.data.termsConditionsConsent === true,
    joinedOn: s => s.data.joinedOn,
    email: s => s.data.email,
    isFeatureEnabled: s => (feature) => {
      const { features } = s.data

      if (!features) return false

      return !!features.find(({ id }) => id === feature)
    }
  },
  mutations: {
    ...platformMutations,
    saveAccount: (s, account) => {
      Vue.set(s, 'data', account)
    }
  }
}
